import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    let bsContainer = this.element.dataset['bsContainer'] || 'body';
    this.popover = new bootstrap.Popover(this.element, { container: bsContainer });
  }

  disconnect() {
    if (this.popover)
      this.popover.dispose();
  }
}